import React, { useState } from 'react';
import { Modal, Select } from 'antd';
import { ButtonCommon } from 'components/common';
import { ProductVersion } from 'models';

interface ReplaceVersionModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: (selectedVersion: string) => void;
  versions: ProductVersion[];
  isUpdating?: boolean;
}

const ReplaceVersionModal: React.FC<ReplaceVersionModalProps> = ({
  isOpen,
  onCancel,
  onConfirm,
  versions,
  isUpdating = false,
}) => {
  const [selectedVersion, setSelectedVersion] = useState<string>(versions[0]?.id || '');

  const handleSelect = (value: string) => {
    setSelectedVersion(value);
  };

  const handleSubmit = () => {
    if (selectedVersion) {
      onConfirm(selectedVersion);
    }
  };

  return (
    <Modal
      open={isOpen}
      onCancel={onCancel}
      footer={null}
      width={520}
      centered
      className='replace-version-modal'
      closeIcon={null}
      maskClosable={false}
    >
      <div className='bg-white rounded-lg flex flex-col overflow-hidden'>
        <div className='px-6 py-3'>
          <div className='text-black text-xl font-bold leading-normal mb-1'>CHỌN VERSION KÍCH HOẠT THAY THẾ</div>
          <div className='text-zinc-500 text-sm font-normal leading-tight'>
            Bạn bắt buộc phải chọn một version để kích hoạt thay thế
          </div>
        </div>
        <div className='px-6 py-3 bg-Background-Grey flex flex-col gap-3'>
          <div className='px-6 py-3 rounded-2xl'>
            <div className='text-black text-sm font-medium leading-tight mb-2'>Chọn version khác:</div>
            <Select
              showSearch
              placeholder='Chọn version'
              value={selectedVersion}
              onChange={handleSelect}
              className='w-full'
              options={versions.map((version) => ({
                value: version.id,
                label: version.version,
              }))}
            />
          </div>
          <div className='flex justify-end gap-6 mt-2'>
            <ButtonCommon color='none' size='sm' radius='rounded' onClick={onCancel}>
              Trở lại
            </ButtonCommon>
            <ButtonCommon
              color='primary'
              size='sm'
              radius='rounded'
              onClick={handleSubmit}
              loading={isUpdating}
              isDisabled={!selectedVersion}
            >
              Xác nhận
            </ButtonCommon>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ReplaceVersionModal;
